var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{staticClass:"fill-current",attrs:{"width":"20","height":"20","rx":"10"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 11H6V9H14V11Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }